import React from "react";

import { Container } from "./styles";

interface ButtonSubmitProps {
  type?: "button" | "submit" | "reset" | undefined;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  children: React.ReactNode;
}

export const ButtonSubmit: React.FC<ButtonSubmitProps> = ({
  children,
  type = "submit",
  style,
  onClick,
  disabled,
}) => {
  return (
    <Container disabled={disabled} onClick={onClick} type={type} style={style}>
      {children}
    </Container>
  );
};
